import TabNavPeriodos from './TabNavPeriodos.component';

export default TabNavPeriodos;
